import { action, computed, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

import type { FactTrajectoryPointEntity } from './fact-trajectory-point.entity';

export class FactTrajectoryEntity {
  readonly entityId = v4();
  // private _initialData: TFactTrajectory = {};

  // @observable private _data: TFactTrajectory = {};
  @observable.ref private _points: FactTrajectoryPointEntity[] = [];

  constructor(initialPoints: FactTrajectoryPointEntity[]) {
    // this._initialData = initialData ?? {};
    // this._data = initialData ?? {};

    this._points = initialPoints;

    makeObservable(this);
  }

  @computed
  get points(): FactTrajectoryPointEntity[] {
    return this._points;
  }

  @computed
  get pointsMap(): Map<string, FactTrajectoryPointEntity> {
    return new Map(this._points.map((point) => [point.entityId, point]));
  }

  @action.bound
  addPoint(point: FactTrajectoryPointEntity): void {
    this._points.push(point);
  }

  @action.bound
  removePoint(point: FactTrajectoryPointEntity): void {
    this._points = this._points.filter((p) => p.entityId !== point.entityId);
  }
}
